import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import {
  AssaignCampaignConfig,
  EmailConfig,
  SuperEmailConfig,
} from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { NodeFactory } from '@modules/campaigns/Domain/Factories/NodeFactory';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';

export class AssaignCampaignNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: AssaignCampaignConfig) {
    super(id, NodeType.AssignCampaign, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['targetCampaignId'] == null;
  }

  addChild(node: string): void {
    //As example, I can't throw an exception because the event in Joint Js is throwing multiple events at once
    return;
    //throw new Error('Cannot add child in Assign Campaign');
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  initNodeConfig(): void {
    (this.config as AssaignCampaignConfig).targetCampaignId = null;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    if (this.isEmptyConfig()) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_TARGET_IDS, {
        nodoType: 'Asignar Campaña',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    return errors;
  }
}
